import { useAsyncStoryblokQuery } from './useAsyncStoryblokQuery'

export const useAsyncStoryblokStoryQuery = async (params = {}) => {
  const key = 'stories'
  const slug = 'cdn/stories/'

  return useAsyncStoryblokQuery(key, slug, params)
}
